/**
 * @param  {string}     string: Remove all blanks
 * @return {string}     formatted string without blanks
 */
export const stripAllBlanks = (value = '') => value.replace(/\s/g, '');

/**
 * @param  {string}     string: Remove repeated zeros
 * @return {string}     formatted string with one zero pero chain of zeros
 */
export const stripRepeatedZeros = (value = '') => value.replace(/0+/g, '0');

/**
 * @param  {string}     string: Remove non digit characters
 * @return {string}     formatted string with only digits
 */
export const stripNonDigits = (string: string): string =>
    string.replace(/[^0-9]/g, '');

export const inIframe = (): boolean => window.top !== window.self;

export const normalizeLocale = (locale: string): string =>
    locale.replace('_', '-');
